export const biryani=[
    {
      "quantity":1,
      "id":15,
    "name":"Classic Biryani Combo",
    "detail":"Large portions of Biryani rice with 2 pc Hot & Crispy, 2 Gravies, 4 Strips & Pepsi PET",
    "price":740.00,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002166.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":16,
    "name":"Smoky Grilled Biryani Combo",
    "detail":"Large portions of Biryani rice with 2 pc Smoky Red, 2 Gravies, Med Popcorn & Pepsi PET",
    "price":740.00,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002017.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":17,
    "name":"Popcorn Biryani Combo",
    "detail":"Large portions of Biryani & Chicken Popcorn, 2 Spicy Gravies, 4pc Wings & Pepsi PET",
    "price":690.48,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002052.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":18,
    "name":"Classic Chicken Biryani Bucket (Large",
    "detail":"Large portions of Biryani rice served with 2 pc Hot & Crispy Chicken & 2 Gravies",
    "price":475.24,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K626.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":19,     
    "name":"Popcorn Chicken Biryani Bucket (Large",
    "detail":"Large portions of Biryani rice served with Chicken Popcorn & 2 Gravies",
    "price":475.24,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K627.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":20,
    "name":"Smoky Grilled Biryani Bucket (Large",
    "detail":"Large portions of Biryani rice served with 2 pc Smoky Red Chicken & 2 Gravies",
    "price":475.24,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K628.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":21,
    "name":"Classic Chicken Biryani Bucket",
    "detail":"Hyderabadi style Biryani rice served with 1 pc Hot & Crispy & Spicy Gravy",
    "price":229.52,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K623.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":22,
    "name":"Popcorn Chicken Biryani Bucket",
    "detail":"Hyderabadi style Biryani rice served with Popcorn & Spicy Gravy",
    "price":229.52,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K624.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":23,
    "name":"Smoky Grilled Biryani Bucket",
    "detail":"Hyderabadi style Biryani rice served with 1 pc Smoky Red & Spicy Gravy",
    "price":229.52,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K625.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":24,
    "name":"Veg Biryani Bucket",
    "detail":"Hyderabadi style Biryani rice served with Veg Patty & Spicy Gravy",
    "price":188.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K622.jpg?ver=20.85"
    }
    ];